import { ApiResponse, getRequest, postRequest } from "@/data/apiClient";
import { SelectOption } from "@micad/vue-components/src/common/interfaces";

export interface Role {
  id: number;
  name: string;
}

export interface Application {
  applicationId: string;
  applicationTitle: string;
  value?: { label: string; value: number };
  options?: SelectOption[];
  roles: Role[];
  hidden?: boolean;
}

export async function getAppRoles(): Promise<ApiResponse<Application[]>> {
  return getRequest("roles", {});
}

export async function getUserRoles(
  userId: number
): Promise<ApiResponse<Role[]>> {
  return getRequest("user/roles", { userId });
}

export async function setUserRoles(
  userId: number,
  roleIds: number[]
): Promise<ApiResponse<unknown>> {
  return postRequest("user/setRoles", { userId, roleIds });
}

export async function setUserProfiles(
  userId: number,
  userProfileIds: number[]
): Promise<ApiResponse<unknown>> {
  return postRequest("user/setUserProfiles", { userId, userProfileIds });
}
